import {getBid, updateBid} from "./bidding_api";
import {BidBaseModel, BidExtendedModel, BidStatus} from "../bid/bidding_model";
import CreateBidForm from "./CreateBid";
import {WithLoggedInAuthInfoProps, withRequiredAuthInfo,} from "@propelauth/react";
import React, {useContext, useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {Cell, cellsDecoder, cellsEncoder} from "../project_conf/bidConfig_model";
import FilesView from "../files/FilesView";
import {Card, CardContent, CardHeader, CardTitle} from "../ui/card";
import {CopyButton2} from "../exportData/CopyButton";
import {copySheetDataToClipboard} from "../project_conf/datasheetHelpers";
import DataSheet from "../project_conf/DataSheet";
import {SubmitHandler} from "react-hook-form";
import {useToast} from "../ui/use-toast";
import {BidConversation} from "../bid/BidConversation";
import {BidHeader} from "./BidHeader";
import BaseLoadingSpinner from "../ui/baseLoadingSpinner";
import {ProjectContext} from "../../contexts/ProjectContext";
import {CompanyType} from "../../models/company";

type BidViewProps = WithLoggedInAuthInfoProps & {
    editable?: boolean;
    create?: boolean;
};

/*
*
* */
function BidView({accessToken}: BidViewProps) {

    const location = useLocation();
    const projectUserContext = useContext(ProjectContext);
    const {toast} = useToast();
    const navigate = useNavigate();
    const {project_id, bid_id} = useParams<string>();
    const [bid, setBid] = useState<BidExtendedModel | null>(null);
    const [sheetData, setSheetData] = React.useState<Cell[][] | null>(null);
    const [isEditing, setIsEditing] = React.useState<boolean>(true);

    useEffect(() => {
        getBid(project_id as string, bid_id as string, accessToken)
            .then((data) => {
                    setValues(data);
                    console.log(data);
                }
            );
    }, [project_id, bid_id]);

    const canEdit =
        projectUserContext?.role === CompanyType.builder &&
        bid?.status !== BidStatus.Submitted;

    useEffect(() => {
        if (!canEdit) {
            setIsEditing(false);
        }
    }, [canEdit, bid?.status]);


    const setValues = (data: any) => {
        setBid(data);
        if (data.custom_data) {
            setSheetData(cellsDecoder(data.custom_data.cells));
        }
    }

    const onSave: SubmitHandler<BidBaseModel> = (data: BidBaseModel) => {
        if (data.bid_amount < 0) {
            toast({
                title: "Error",
                description: "Bid amount must be greater than 0.",
                variant: "destructive",
            });
            return;
        }
        if (!bid_id) {
            return;
        }

        let submit_data = {...data};

        if (sheetData) {
            // @ts-ignore
            submit_data.custom_data.cells = cellsEncoder(sheetData);
        }
        updateBid(accessToken, project_id as string, bid_id, submit_data)
            .then((data) => {
                toast({
                    title: "Success!",
                    description: "Update Successful",
                    variant: "default",
                });
                setIsEditing(false);
            })
            .catch((error) => {
                console.error("Error updating bid:", error);
                toast({
                    title: "Error",
                    description: "Failed to update bid: " + JSON.stringify(error),
                    variant: "destructive",
                });
            });

    };

    const onSubmitBid = (values: BidBaseModel) => {
        if (!bid_id) {
            return;
        }
        values.status = BidStatus.Submitted;
        if (sheetData) {
            // @ts-ignore
            values.custom_data.cells = cellsEncoder(sheetData);
        }
        updateBid(accessToken, project_id as string, bid_id, values)
            .then((data) => {
                toast({
                    title: "Success!",
                    description: "Bid submitted successfully.",
                    variant: "default",
                });

                setIsEditing(false);
                // setValues(data);
                navigate(0);
                // navigate(`/project/${project_id}/bid/${bid_id}`);
            })
            .catch((error) => {
                console.error("Error submitting bid:", error);
                toast({
                    title: "Error",
                    description: JSON.stringify(error) || "Failed to submit bid.",
                    variant: "destructive",
                });
            });
        console.log("values", values);

    };

    if (!bid) {
        return <div><BaseLoadingSpinner/></div>;
    }

    return <div className="container">

        {/* CONTROLS - they can stay with FORM for now...but yikes. */}

        {/*----------------------------------------*/}
        {/* FORM */}
        <br/>
        <div className="columns-2 flex justify-between">
            <div className={bid.status === BidStatus.Submitted ? "w-8/12 mr-4" : "w-full"}>
                <BidHeader bid={bid}/>
                <CreateBidForm
                    editable={true}
                    bid={bid}
                    create={false}
                    isEditing={isEditing}
                    setIsEditing={setIsEditing}
                    onSubmit={onSubmitBid}
                    onSave={onSave}
                />

                {/*----------------------------------------*/}
                {/*DATASHEET */}
                <br/>
                {sheetData ? (
                    <Card>
                        <CardHeader>
                            <CardTitle className="columns-2 flex justify-between">
                                <div>Additional Info</div>
                                <CopyButton2
                                    dataTransform={() => sheetData}
                                    executeCustomCopy={copySheetDataToClipboard}
                                />
                            </CardTitle>
                        </CardHeader>
                        <CardContent>
                            <DataSheet
                                data={sheetData}

                                setData={setSheetData}
                                enable_row_col={false}
                                readonly={!canEdit}
                                // readonly={!isEditing}
                            />
                        </CardContent>
                    </Card>
                ) : (
                    <></>
                )}

                {/*----------------------------------------*/}
                {/*FILES*/}
                <br/>
                <FilesView
                    uploadContext={{
                        context: "bidding",
                        permission: "view",
                        project_id: project_id,
                        parent_id: bid_id as string,
                        parent_type: "bidding",
                        url: location.pathname,
                        folder_id: bid?.root.id,
                        editing: canEdit,
                    }}
                />

            </div>

            {/*----------------------------------------*/}
            {/* Conversation */}
            {/* TODO */}
            {bid.status === BidStatus.Submitted ?
                <div className="w-4/12 ">
                    <BidConversation parent_type={"bidding"} parent_id={bid.id}/>
                </div>
                : <></>
            }
        </div>


    </div>;
}

export default withRequiredAuthInfo(BidView);
